import plpInfoCard from "./plp/info-card";
plpInfoCard();